import axios from "axios";
import { otpFail, otpRequest, otpSuccess, otpVerified, resendOtpSuccess } from "./otp.reducer";

export const sendOtp = (email) => async (dispatch) => {
    dispatch(otpRequest());
    try {
        console.log(email)
      const response = await axios.post("https://tiffin-managment-system.onrender.com/api/v1/user/sendotp", email);
      dispatch(otpSuccess(response.data));
    } catch (error) {
      dispatch(otpFail(error.response.data.message));
    }
  };
  export const resendOtp = (email) => async (dispatch) => {
    
    try{
       
      const response = await axios.post("https://tiffin-managment-system.onrender.com/api/v1/user/sendotp", email);
       dispatch(resendOtpSuccess(response.data));
    } catch (error) {
      dispatch(otpFail(error.response.data.message));
    }
  };
  
  // Thunk action for verifying OTP
  export const verifyOtp = (Otp) => async (dispatch) => {
    dispatch(otpRequest());
    try {
      const response = await axios.post("https://tiffin-managment-system.onrender.com/api/v1/user/verifyotp",Otp);
      dispatch(otpVerified(response.data));
    } catch (error) {
      dispatch(otpFail(error.response.data.message));
    }
  };